import { render, staticRenderFns } from "./AssistantStep.vue?vue&type=template&id=f73aa632&scoped=true&"
import script from "./AssistantStep.vue?vue&type=script&lang=js&"
export * from "./AssistantStep.vue?vue&type=script&lang=js&"
import style0 from "./AssistantStep.vue?vue&type=style&index=0&id=f73aa632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73aa632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFlex,VIcon})
